import AccountController from './accountController';
import ProfileModel from '../models/profileModel';
import StoreModel from '../models/storeModel';
import ProfileViewModel from '../viewModels/profileViewModel';
import ProfileTemplate from '../../templates/profile.j2';
import * as AuthController from './authController';
import ErrorController from './errorController';
import HeaderController from './headerController';

/**
 * Controller used for /profile
 */
class ProfileController extends AccountController {
    constructor(model, viewModel, template) {
        super();

        this.ProfileModel = model;
        this.ProfileViewModel = viewModel;
        this.ProfileTemplate = template;
        this.self = this;
    }
    /**
     * Contains promise chain used to render contents on the profile page
     * Called From:
     * router.route('profile').enter()
     */
    render(store) {
        ProfileModel.createLoader();
        // set session if retrieved from API
        AuthController.authenticate()
        .then(session => {
            return AuthController.saveSession(session);
        })
        // render header
        .then(session => {
            return HeaderController.render(store);
        })
        // get preferences info
        .then(profile => {
            console.log("getPreferences");
            return super.get(ProfileModel, 'getPreferences', AuthController.get('session'), 'preferences');
        })
        // save preferences info to model
        .then(preferencesData => {
            console.log("preferences");
            return super.set(ProfileModel, preferencesData, 'preferences');
        })
        .then(preferencesDataNotUsed => {
            console.log("favorite stores");
            return ProfileModel.preferences.global.favoriteStores;
        })
        .then(favoriteStores => {
            console.log("favorite stores");
            return StoreModel.storeInit(favoriteStores);
        })
        .then(profile => {
            console.log("update employeeId");
            return ProfileModel.updateEmployeeId();
        })
        .then(profile => {
            console.log("generate bar code");
            return ProfileModel.generateBarCode();
        })
        // generate template
        .then(profile => {
            console.log("generate template");
            return super.generateTemplate(profile, ProfileTemplate, ProfileModel, ProfileViewModel, 'Profile', store);
        })
        // attach template to DOM
        .then(template => {
            console.log("attach to dom");
            return super.attachTemplateToDom(template);
        })
        .then(DOM => {
            console.log("attachMap");
            return StoreModel.attachMap(DOM);
        })
        // attach events to DOM
        .then(DOM => {
            console.log("Removing loader");
            ProfileModel.destroyLoader();
            console.log(ProfileModel);
            console.log(ProfileViewModel);
            return super.attachEvents(ProfileViewModel, this, ProfileModel, AuthController.get('session'), store);
        })
        // catch any errors
        .catch(error => {
            ProfileModel.destroyLoader();
            console.log(error);
            if(error.type === 'serviceError') {
                ErrorController.handleErrors(error, ProfileModel, ProfileViewModel, this);
            }
        });
    }

    /**
     * Promise chain that contains non-critical functionality
     * @param  {object} store The current state of the redux store
     * @return {object}       The value of attached or handleErrors
     */
    postRender(store) {
        ProfileModel.createLoader();
        // make call to subscriptions services for email and loyalty subscription info
        super.get(ProfileModel, 'getSubscriptions', AuthController.get('session'), 'subscriptions', ProfileViewModel)
        // save subscription info to model
        .then(subscriptionData => {
            console.log("subscriptions");
            return super.set(ProfileModel, subscriptionData, 'subscriptions', ProfileViewModel);
        })
        .then(profile => {
            console.log("generate template");
            return super.generateTemplate(profile, ProfileTemplate, ProfileModel, ProfileViewModel, 'Profile', store);
        })
        // attach template to DOM
        .then(template => {
            console.log("attach to dom");
            return super.attachTemplateToDom(template);
        })
        // if on profile
        .then(DOM => {
            return ProfileViewModel.generateQrCode(DOM, 'qr-code', ProfileModel);
        })
        // attach events to DOM
        .then(DOM => {
            console.log("Destroy loader");
            ProfileModel.destroyLoader();
            console.log(ProfileModel);
            console.log(ProfileViewModel);
            console.log(store);
            return super.attachEvents(ProfileViewModel, this, ProfileModel, AuthController.get('session'), store);
        })
        // catch any errors
        .catch(error => {
            console.log(error);
            ProfileModel.destroyLoader();
            if(error.type === 'serviceError') {
                ErrorController.handleErrors(error, ProfileModel, ProfileViewModel, this, '', '', '', store);
            }
        });
    }

}

// Create an object from the ProfileController class
const profile = new ProfileController(ProfileModel, ProfileViewModel, ProfileTemplate);
// Export object created from ProfileController class
export default profile;
